
















































































export default {
  name: "OurStaff",
  data() {
    return {
      executives: [
		  	{
			  	name : 'Msgr. Paul',
				position: 'Director',
				image : require('../assets/images/msgr-paul.jpg'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
			{
			  	name : 'Sr. Mafel',
				position: 'Admin Head',
				image : require('../assets/images/sr-mafel.jpg'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
			{
			  	name : 'Sr. Violy',
				position: 'Operations In-charge - Fatima',
				image : require('../assets/images/sr_violy.png'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
			{
			  	name : 'Sr. Merge',
				position: 'Operations In-charge - Bucana',
				image : require('../assets/images/sr-merge.png'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
			{
			  	name : 'Alchie',
				position: 'Finance In-charge',
				image : require('../assets/images/alchie.jpg'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
			{
			  	name : 'Narsing',
				position: 'Bucana Staff',
				image : require('../assets/images/narsing.jpg'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
			{
			  	name : 'Teddy',
				position: 'Fatima Cook',
				image : require('../assets/images/teddy.jpg'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
			{
			  	name : 'Adon',
				position: 'Bucana Cook',
				image : require('../assets/images/adon.jpg'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
	  ],
      volunteers: [
		  {
			  	name : 'Ate Marina',
				position: 'Fatima',
				image : require('../assets/images/ate-marina.jpg'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
		{
			  	name : 'Ate Merlyn',
				position: 'Fatima',
				image : require('../assets/images/ate-merlyn.jpg'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
			{
			  	name : 'Ate Gaga',
				position: 'Fatima',
				image : require('../assets/images/dummy-img-400x400.jpg'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
			{
			  	name : 'Ate Rita',
				position: 'Bucana',
				image : require('../assets/images/rita.jpg'),
				facebook_url : '#',
				twitter_url : '#',
				linkedin_url : '#',
			},
	  ]
    };
  }
};
